import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';

const navItems = [
  { label: '首页', to: '/' },
  { label: '动漫分类', to: '/category' },
  { label: '动漫资讯', to: '/news' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : '/search');
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center gap-3 md:gap-8 h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer" onClick={() => setMenuOpen(false)}>
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-sparkling-2-fill text-xl"></i>
            </span>
            <span className="font-brand text-2xl text-primary-600 leading-none">妖精动漫</span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="px-4 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <form onSubmit={handleSearch} className="hidden md:flex items-center flex-1 max-w-md ml-auto">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索动漫或资讯…"
                className="w-full h-10 pl-10 pr-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
              />
            </div>
            <button
              type="submit"
              className="ml-2 h-10 px-5 rounded-full bg-accent-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <div className="px-4 py-4 space-y-4">
            <form onSubmit={handleSearch}>
              <div className="relative w-full">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索动漫或资讯…"
                  className="w-full h-11 pl-10 pr-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
                />
              </div>
            </form>
            <nav className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                  className="px-4 py-3 rounded-lg bg-background-100 text-sm font-medium text-foreground-800 text-center hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}